<div class="form-inline mr-2 d-flex take-off-depth-container" *ngIf="isDepthEnabled">
    <form class="input-group mr-2" [formGroup]="depthUnitForm">
        <span class="input-group-addon">{{ title }}</span>

        <input legacy-css class="form-control depth-input" type="number" formControlName="depth" />

        <div class="input-group-addon depth-span">
            <select legacy-css class="form-control depth-select" required formControlName="depthUnit">
                <option *ngFor="let depthUnit of depthUnits" [value]="depthUnit">{{ depthUnit }}</option>
            </select>
        </div>
    </form>
</div>
